export async function listAgents(ctx, workspaceId) {
    const cache = ctx.shell.structuredCache;
    if (cache) {
        const cached = await cache.listAgents(workspaceId);
        if (cached.length > 0)
            return cached;
    }
    return ctx.hub.listAgents(workspaceId);
}
/**
 * Agent lifecycle helpers. Each requires the shell to provide
 * `AgentLifecycleAdapter` — Web does not. Throws `AgentLifecycleUnsupported`
 * if called on a shell without the capability, so UI code can gate via a
 * try/catch or by checking `ctx.shell.agents` directly before invoking.
 */
export class AgentLifecycleUnsupported extends Error {
    constructor(operation) {
        super(`Agent lifecycle operation '${operation}' requires a shell that implements AgentLifecycleAdapter.`);
        this.name = "AgentLifecycleUnsupported";
    }
}
function requireAgents(ctx, operation) {
    if (!ctx.shell.agents)
        throw new AgentLifecycleUnsupported(operation);
    return ctx.shell.agents;
}
export async function createAgent(ctx, input) {
    return requireAgents(ctx, "create").create(input);
}
export async function startAgent(ctx, agentId, options) {
    return requireAgents(ctx, "start").start(agentId, options);
}
export async function stopAgent(ctx, agentId) {
    return requireAgents(ctx, "stop").stop(agentId);
}
export async function deleteAgent(ctx, agentId) {
    return requireAgents(ctx, "delete").delete(agentId);
}
export function onAgentStatusChanged(ctx, listener) {
    const agents = ctx.shell.agents;
    if (!agents)
        return () => undefined;
    return agents.onStatusChanged(listener);
}
//# sourceMappingURL=agents.js.map